import { NetworkService } from '../../../../services/networkService';
import { getTimeDateString } from '../../../../utility/date';

export const addTask = async (values, id) => {
  const payload = {
    task: {
      image_ids: values.attachments.map((img) => img.id),
      task_type_id: values.completedTaskType,
      notes: values.notes,
      task_purpose_id: values.completedsubTaskType,
      completed_at: getTimeDateString(values.completionDate, false, true),
      due_date: getTimeDateString(values.dueDate, false, true),
      taskable_id: id,
      taskable_type: 'Lead',
      listing_id: values?.taskInterest?.id,
      child_attributes: {
        task_type_id: values.plannedTaskType,
        task_purpose_id: values.plannedsubTaskType,
        due_date: getTimeDateString(values.dueDate, false, true),
        taskable_id: id,
        taskable_type: 'Lead',
        listing_id: values?.taskInterest?.id,
      },
    },
  };

  const response = await NetworkService.post(`/api/lms/tasks`, payload);
  if (response) {
    if (response.error) {
      return response;
    } else if (response?.data) {
      return response?.data;
    } else {
    }
  }
};
